module.exports = __webpack_public_path__ + "static/Food Safety Specialist.ffa7469c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Food Safety Specialist.jpg
// module id = 390
// module chunks = 246227742792961